import { InitialState } from "./state";

export default {
  ...InitialState,
  numAjaxCallsInProgress: 0,
  import: {
    uploading: false,
    saving: false,
    import: {},
    self: [],
  },
  styles: {
    isDark: false,
  },
  tokens: {},
};
